'use client';

import { c as _c } from "react/compiler-runtime";
import type { Data } from '@repo/strapi-types';
import { MarketoForm } from '@/app/[locale]/blog/_components/MarketoForm';
import AppLink from '@/components/elementary/AppLink';
import { Skeleton } from '@/components/ui/skeleton';
import { MARKETO_FORM_IDS } from '@/lib/constants';
import { ARTICLE_SIDEBAR_TEST_IDS } from '@/lib/test-ids';
export const ArticleSidebarForm = t0 => {
  const $ = _c(2);
  const {
    sidebar
  } = t0;
  let t1;
  if ($[0] !== sidebar) {
    t1 = sidebar?.downloadLink?.href ? <AppLink link={sidebar.downloadLink} variant="primary" size="medium" className="w-full" data-test-id={ARTICLE_SIDEBAR_TEST_IDS.DOWNLOAD_LINK}>{sidebar.downloadLink?.label}</AppLink> : <MarketoForm id={sidebar?.marketoFormId ?? MARKETO_FORM_IDS.BLOG_SUBSCRIPTION} loadingSkeleton={<BlogSubscriptionSkeleton />} />;
    $[0] = sidebar;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const BlogSubscriptionSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex flex-col gap-3.75"><Skeleton className="h-11.25 w-full" /><Skeleton className="h-11.25 w-full rounded-full" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};